import Vue from 'vue';
const vue = new Vue({});

export default function auth({ next, router }) {
  if (!vue.$localStorage.get('user')) {
    return router.push({ name: 'Login' });
  }

  return next();
}
